import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import MainArea from "../components/MainArea";
import ColoredBlock from "../components/ColoredBlock";
import ColoredSignUp from "../components/ColoredSignUp";
import {
  Image,
  CardDeck,
  Card,
  Container,
  Carousel,
  Row,
  Col,
  Media,
} from "react-bootstrap";
import Banner from "../images/trial.png";
import Protud from "../images/protude.png";
import UnderstandBetter from "../images/understand_better.png";
import ResumeReady from "../images/resume_ready.png";
import ReadingHabit from "../images/reading_habit.png";
import Sarvesh from "../images/sarv.png";
import ProtudeLogo from "../images/protude_logo.png";
import "../css/Landing.css";
import HeaderAll from "../components/HeaderAll";
import SignUp from "../components/SignUp";
import { useStateValue } from "../Stateprovider";
import ColoredHead from "../components/ColoredHead";
import { db } from "../firebase";

function Landing(props) {
  const [{ user }, dispatch] = useStateValue();
  const [topProjects, setTopProjects] = useState([]);

  useEffect(() => {
    db.collection("topprojects").onSnapshot((snapshot) =>
      setTopProjects(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      )
    );
  }, []);

  return (
    <div>
      {/* <IndexNavbar /> */}
      <HeaderAll></HeaderAll>
      <Image src={Protud} fluid className="landing__image" />
      {/* <Header></Header> */}
      <br></br>
      <br></br>
      <br></br>
      {/* <HeaderAll></HeaderAll> */}
      <Row>
        <Col md className="mr-0 ml-0 pr-0">
          <ColoredBlock
            color={"#FFC924"}
            text={"Learn as you do"}
            subtext={
              "build up your resume using our guided projects. Develop your skills by looking up our hand picked references and study materials."
            }
            textcolor={"#29285D"}
          ></ColoredBlock>
        </Col>
        <Col md className="mr-0 ml-0 pl-0">
          {user ? (
            <ColoredBlock
              color={"#469bd8"}
              text={"Quick and Efficient"}
              subtext={
                "Watching tutorial is time consuming. The result along with those might give you a ready project but what you gain is much less when you compare it with protude projects."
              }
              textcolor={"#FFFFFF"}
            ></ColoredBlock>
          ) : (
            <ColoredSignUp color={"#469bd8"}></ColoredSignUp>
          )}
        </Col>
      </Row>

      <Row>
        <ColoredHead color={"#df682d"} middle={UnderstandBetter}></ColoredHead>
        <ColoredHead color={"#62a25d"} middle={ResumeReady}></ColoredHead>
        <ColoredHead color={"#29285D"} middle={ReadingHabit}></ColoredHead>
      </Row>

      {/* REPEAT */}
      <Row>
        <Col md className="mr-0 ml-0 pr-0">
          <ColoredHead
            color={"#80DCF1"}
            end={
              <div>
                <h2>"Protude, Learn things correctly."</h2>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </div>
            }
            middle={ProtudeLogo}
            textcolor={"#29285D"}
          ></ColoredHead>
        </Col>
        <Col md className="mr-0 ml-0 pr-0 pl-0">
          <ColoredHead
            color={"#Fdcbdf"}
            middle={Sarvesh}
            textcolor={"#000000"}
          ></ColoredHead>
        </Col>
      </Row>
      <div className="landing__zero">
        <Container>
          <center>
            <h1>Our Top Performing Projects</h1>
          </center>
          <CardDeck>
            {/* <Row> */}
            {topProjects?.map((projects) => (
              // <Col md="6">
              <Card style={{ minWidth: "18rem" }} className="mt-2">
                <Card.Img variant="top" src={projects.data.imageLink} />
                <Card.Body>
                  <Card.Title>{projects.data.title}</Card.Title>
                  <Card.Text>{projects.data.description}</Card.Text>
                </Card.Body>
                <Card.Footer>
                  <small className="text-muted">
                    {projects.data.downloads}+ Downloads
                  </small>
                </Card.Footer>
              </Card>
              // </Col>
            ))}
          </CardDeck>
        </Container>
        <br></br>
        <br></br>
        <center>
          <h1>____</h1>
        </center>
      </div>
      {/* Make everything inside white. */}

      <br></br>

      <div>
        <footer>Copyright @RevoltronX, contact@revoltronx.com</footer>
      </div>
    </div>
  );
}

export default Landing;

{
  /* <Carousel>
        <Carousel.Item>
          <img className="d-block w-100" src={Banner} alt="First slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={Banner} alt="Third slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={Banner} alt="Third slide" />
        </Carousel.Item>
      </Carousel> */
}
